import { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form/dist/index.ie11';
import { InsightsFormFields } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsFormWrapper/InsightsFormWrapper';
import { DATE_RANGE_KEY } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/constants/businessInsights';

interface InsightsAutoSubmitProps {
  onSubmit: (data: InsightsFormFields) => void;
}

export const useInsightsAutoSubmit = ({
  onSubmit,
}: InsightsAutoSubmitProps): void => {
  const {
    handleSubmit,
    formState: { isDirty },
  } = useFormContext<InsightsFormFields>();

  const formValues = useWatch<InsightsFormFields>({});

  const hasUserInteracted = useRef(isDirty);
  if (isDirty) {
    hasUserInteracted.current = true;
  }

  const dateRange = formValues?.[DATE_RANGE_KEY];
  const isDateRangeComplete = Boolean(dateRange?.from && dateRange?.to);

  const valuesSnapshot = JSON.stringify(formValues);
  const lastSubmittedSnapshot = useRef<string | null>(null);

  useEffect(() => {
    if (!hasUserInteracted.current || !isDateRangeComplete) {
      return;
    }

    const isSameFormValues = lastSubmittedSnapshot.current === valuesSnapshot;

    if (isSameFormValues) {
      return;
    }

    lastSubmittedSnapshot.current = valuesSnapshot;

    handleSubmit(onSubmit)();
  }, [valuesSnapshot, isDateRangeComplete, handleSubmit, onSubmit]);
};
